export default class ContactModal {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('#kontaktModal:not([data-cm-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-cm-init', "1");

			item.addEventListener("show.bs.modal", function (event) {
				// Tlačítko, které spustilo modal
				const button = event.relatedTarget;

				// Získání dat z data atributů
				const firma = button.getAttribute("data-kontakt-firma");
				const ulice = button.getAttribute("data-kontakt-ulice");
				const mesto = button.getAttribute("data-kontakt-mesto");
				const telefon = button.getAttribute("data-kontakt-telefon");
				const email = button.getAttribute("data-kontakt-email");
				const web = button.getAttribute("data-kontakt-web");

				// Aktualizace obsahu modalu
				document.getElementById("kontaktFirma").textContent = firma || "";
				document.getElementById("kontaktUlice").textContent = ulice || "";
				document.getElementById("kontaktMesto").textContent = mesto || "";
				document.getElementById("kontaktTelefon").textContent = telefon || "";

				const emailElement = document.getElementById("kontaktEmail");
				emailElement.textContent = email || "";
				emailElement.href = email ? "mailto:" + email : "";

				const webElement = document.getElementById("kontaktWeb");
				webElement.textContent = web || "";
				webElement.href = web || "#";
			});
		});
	}
}
